import { BaseDataModel } from "@domain/CRM/BaseDataModel";
import type { TeamRoleOption, TeamStatusOption } from "./TeamRole";

export class TeamMember extends BaseDataModel {
	name!: string;
	missionControlUsername!: string;
	appUserId!: number;
	password?: string;
	status!: TeamStatusOption;
	roles?: TeamRoleOption[];
	phoneNumber!: string;
	isAppLoginApproved!: boolean;
}

/** Fields needed to create (onboard) a new operator + its login password.
 *  The App Username is derived server-side from the name, so it isn't supplied here. */
export interface CreateOperatorInput {
	name: string;
	password: string;
	phoneNumber: string;
	status: TeamStatusOption;
	roles: TeamRoleOption[];
	isAppLoginApproved: boolean;
}

/** Fields needed to issue a login to an operator that already exists: a fresh password
 *  plus the same employee fields `CreateOperatorInput` collects. The name and the App
 *  Username are the record's own (the server derives a username if it has none). */
export interface UpdateOperatorLoginInput {
	teamMemberId: string;
	password: string;
	phoneNumber: string;
	status: TeamStatusOption;
	roles: TeamRoleOption[];
	isAppLoginApproved: boolean;
}
